'use client'

import { useState } from 'react'
import { Coins } from 'lucide-react'
import clsx from 'clsx'

const TAX_TYPES = [
  { id: 'TTDB', label: 'Thuế tiêu thụ đặc biệt' },
  { id: 'BVMT', label: 'Thuế bảo vệ môi trường' },
  { id: 'CBPG', label: 'Thuế chống bán phá giá' },
]

export default function HSTaxFilter({
  setSelectedTaxTypes,
  selectedTaxTypes,
}: {
  setSelectedTaxTypes: any
  selectedTaxTypes: string[]
}) {
  const [isOpen, setIsOpen] = useState(false)

  const handleClearAll = () => {
    setSelectedTaxTypes([])
  }

  // Get selected tax names for display
  const selectedTaxNames =
    selectedTaxTypes.length === 0
      ? 'Sắc thuế phải nộp khác'
      : selectedTaxTypes.length === 1
        ? TAX_TYPES.find((t) => t.id === selectedTaxTypes[0])?.label || ''
        : `${TAX_TYPES.find((t) => t.id === selectedTaxTypes[0])?.label?.split(' ')[0]}... (+${selectedTaxTypes.length - 1})`

  return (
    <div className="relative">
      {/* Dropdown Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="hs-filter-button flex items-center gap-2"
      >
        <Coins size={16} className="shrink-0" />
        <span className="truncate font-bold">{selectedTaxNames}</span>
        <svg
          className={clsx(
            'w-3 h-3 transition-transform shrink-0',
            isOpen && 'rotate-180'
          )}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Dropdown Panel */}
      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-[320px] bg-white border border-gray-300 rounded shadow-lg z-50">
          {/* Tax Type List */}
          <div className="p-2">
            {TAX_TYPES.map((tax) => (
              <label
                key={tax.id}
                className={clsx(
                  'px-3 py-2 hover:bg-gray-50 cursor-pointer flex items-center gap-2 rounded text-left',
                  selectedTaxTypes.includes(tax.id) && 'bg-blue-50'
                )}
              >
                <input
                  type="checkbox"
                  checked={selectedTaxTypes.includes(tax.id)}
                  onChange={() =>
                    setSelectedTaxTypes((prev: string[]) =>
                      prev.includes(tax.id)
                        ? prev.filter((id) => id !== tax.id)
                        : [...prev, tax.id],
                    )
                  }
                  className="w-4 h-4 shrink-0"
                />
                <span className="text-sm flex-1">{tax.label}</span>
              </label>
            ))}
          </div>
        </div>
      )}

      {/* Backdrop */}
      {isOpen && (
        <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
      )}
    </div>
  )
}
